<div style="background-color: #ffffff; height: 46%; padding-top: 1%">
    <h1 style="text-align: center; font-weight: bold" translate>Statistiques</h1>
    <span layout="row">
    <hr class="st-hr" flex/>
  </span>

    <div class="content" style="margin-top: 2%">
        <div
                fxLayout="row wrap"
                fxLayoutGap="20px grid"
                style="justify-content: center"
        >
            <!-- <div fxFlex="30%" fxFlex.xs="100%" fxFlex.sm="33%" class="st-height">
                <mat-card  class="mat-elevation-z0 st-matcard">
                  <img mat-card-image class="st-img" src="assets/images/acheteurs enregistrés.svg">
                  <mat-card-content>
                      <p class="st-p">
                          300 562
                        </p>
                    <p class="st-p1">
                      Acheteurs enregistrés
                    </p>
                  </mat-card-content>
                </mat-card>
              </div> -->

            <div [fxFlex]="22" fxFlex.sm="48%" fxFlex.xs="100%" style="height: 20rem">
                <mat-card class="mat-elevation-z4" style="height: 100%">
                    <img
                            class="st-img"
                            mat-card-image
                            src="assets/images/acheteurs.svg"
                    />
                    <mat-card-content>
                        <p class="st-p11" style="text-align: center">
                            {{ nbr_acheteurs }}
                        </p>
                        <p class="st-p1" style="text-align: center">
                            {{ "Acheteurs_enregistres" | translate }}
                        </p>
                    </mat-card-content>
                </mat-card>
            </div>

            <div [fxFlex]="22" fxFlex.sm="52%" fxFlex.xs="100%" style="height: 20rem">
                <mat-card class="mat-elevation-z4" style="height: 100%">
                    <img
                            class="st-img"
                            mat-card-image
                            src="assets/images/fournisseurs_2.svg"
                    />
                    <mat-card-content>
                        <p class="st-p11" style="text-align: center">
                            {{ nbr_fournisseurs }}
                        </p>
                        <p class="st-p1" style="text-align: center">
                            {{ "Fournisseurs_enregistres" | translate }}
                        </p>
                    </mat-card-content>
                </mat-card>
            </div>

            <div [fxFlex]="23" fxFlex.sm="55%" fxFlex.xs="100%" style="height: 20rem">
                <mat-card class="mat-elevation-z4" style="height: 100%">
                    <img
                            class="st-img"
                            mat-card-image
                            src="assets/images/nombreappeloffres1.svg"
                    />
                    <mat-card-content>
                        <p class="st-p11" style="text-align: center">
                            {{ nbr_appels_offres }}
                        </p>
                        <p class="st-p1" style="text-align: center">
                            {{ "Nombres_d_appels_d_offres" | translate }}
                        </p>
                    </mat-card-content>
                </mat-card>
            </div>

            <div [fxFlex]="23" fxFlex.sm="55%" fxFlex.xs="100%" style="height: 20rem">
                <mat-card class="mat-elevation-z4" style="height: 100%">
                    <img
                            class="st-img"
                            mat-card-image
                            src="assets/images/consultation1.svg"
                    />
                    <mat-card-content>
                        <p class="st-p11" style="text-align: center">
                            {{ nbr_consultation }}
                        </p>
                        <p class="st-p1" style="text-align: center">
                            {{ "Nombres_des_consultations" | translate }}
                        </p>
                    </mat-card-content>
                </mat-card>
            </div>
        </div>
    </div>

    <div class="st-separ"></div>
</div>
